module.exports = __webpack_public_path__ + "static/media/location.83f89cb7.svg";